import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c0cce6e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "reaction" }
const _hoisted_2 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      class: _normalizeClass(`reaction_icon ${ _ctx.rounded ? 'mi2' : ''}`),
      src: _ctx.src
    }, null, 10 /* CLASS, PROPS */, _hoisted_2),
    _createTextVNode(" 5 ")
  ]))
}